/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Double_Height_LabelInputs */



/**
* | output |
* | --- |
* | "Double height" |
*
* @param {Embed_Captions_Local_Double_Height_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_double_height_label = /** @type {((inputs?: Embed_Captions_Local_Double_Height_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Double_Height_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Double hauteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Doppelte Höhe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Doppia altezza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Двойная высота")
	if (locale === "es") return /** @type {LocalizedString} */ ("Doble altura")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("双倍高度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("倍角（縦）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दोगुनी ऊँचाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Altura dupla")
	return /** @type {LocalizedString} */ ("Double height")
});